module.exports = __webpack_public_path__ + "static/media/asier.70c4060f.png";